<template>
  <section>
    <!-- Listing Header -->
    <contact-header
      :searchTerm="_searchTerm"
      :pageSize="_pageSize"
      :pages="pages"
      :pageSizes="pageSizes"
      :filterBy="_filterBy"
      :numItems="contacts.count"
      :showFilter="showFilter"
      :title="title"
      @search="search"
      @add="newContact"
      @merge="confirmContactMerge"
    />
    <div
      class="table-responsive"
      :class="{ 'disabled': $loading.isLoading('getContacts') }"
    >
      <!-- Contact Listing -->
      <div
        ref="listingWrapper"
        class="listingWrapper"
      >
        <dt-table
          v-model="contacts.items"
          class="table table-bordered table-striped"
          :isSingleRowDetail="true"
          @sort="setOrder"
          sortOn="id"
          sortDir="asc"
          :columns="tableColumnsName"
          :detailColumnClass="detailColumnClass"
        >
          <template
            slot="tbody"
            slot-scope="props"
          >
            <td class="custom-column-60">
              <contact-checkbox :contact="props.row" />
            </td>
            <td class="custom-column-60">
              <a
                href="#"
                v-if="allowEdit(props.row)"
                @click="editContact(props.row)"
              >edit</a>
            </td>
            <th scope="row">{{ props.row.contact }}</th>
            <td>{{ props.row.firmName }}</td>
            <td>{{ props.row.contactTypeName }}</td>
            <td>{{ props.row.fullName }}</td>
            <td>{{ props.row.emailAddress }}</td>
            <td>{{ props.row.phoneNo }}</td>
            <td class="custom-column-60">
              <a
                href="#"
                v-if="allowEdit(props.row)"
                @click="viewTestDrives(props.row.contact)"
              >test drives</a>
            </td>
          </template>
          <template
            slot="detail"
            slot-scope="props"
          >
            <contact-record
              :recordData="props.row"
              :showTitles="showCommTitles"
            />
          </template>
          <template slot="empty"> Nothing found! </template>
        </dt-table>
      </div>
    </div>
    <dialog-contact-edit
      v-model="actionContactEdit"
      :contactTitle="contactTitle"
      @closing="closeModal"
      @send="sendContact"
    />
    <dialog-contact-add
      v-model="actionContactAdd"
      :contactTitle="contactTitle"
      :isCompany="isCompany"
      @closing="closeModal"
      @send="sendContact"
    />
    <confirm-merge
      v-model="actionMerge"
      @closing="closeModal"
      @send="performContactMerge"
    />
    <dialog-contact-drives
      v-model="actionDrives"
      @closing="closeModal"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DtTable from '@/components/utilities/table/dt-table'
import ContactHeader from '@/components/contacts/listings/contact-listing-header'
import ContactRecord from '@/components/contacts/listings/contact-record'
import ContactCheckbox from '@/components/contacts/forms/contact-checkbox'
import DialogContactEdit from '@/components/contacts/forms/contact-edit'
import DialogContactAdd from '@/components/contacts/forms/contact-add'
import ConfirmMerge from '@/components/contacts/forms/confirm-merge'
import DialogContactDrives from '@/components/contacts/forms/contact-drives-dialog.vue'
export default {
  name: 'contact-listing',
  components: {
    DtTable,
    ContactHeader,
    ContactRecord,
    ContactCheckbox,
    DialogContactEdit,
    DialogContactAdd,
    ConfirmMerge,
    DialogContactDrives
  },
  props: {
    showFilter: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'Contact'
    },
    isCompany: {
      type: Boolean,
      default: false
    },
    contactType: {
      type: String,
      default: 'Insurance'
    }
  },
  data() {
    return {
      actionContactEdit: null,
      actionContactAdd: null,
      actionMerge: null,
      actionDrives: null,
      page: 1,
      pageSizes: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 }
      ],
      detailColumnClass: 'custom-column-60',
      showCommTitles: true,
      contactTitle: 'Contact',
      isLoading: false
    }
  },
  async created() {
    await this.setLookups({
      keys: [
        'ContactType',
        'Salutation',
        'AddressType',
        'PhoneType',
        'EmailType',
        'StateProvince',
        'Country',
        'RelatedContactType',
        'Language',
        'TimeZone',
        'VehicleMake',
        'Fleet',
        'Insurance'
      ],
      firm: this.profile.firm,
      refresh: false
    })
    this.setFilterOptions(this.lookups['ContactType'])
    if (this.isCompany) {
      console.log('Contact Type', this.contactType)
      for (let item of this.lookups['ContactType']) {
        if (item.name === this.contactType) {
          this.setFilterBy(item.id)
          break
        }
      }
    }
    if (this.title !== undefined && this.title !== null) {
      this.contactTitle = this.title
    }
    await this.search(1, this.searchTerm)
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    ...mapGetters('contacts', [
      'contacts',
      'status',
      'pageSize',
      'searchTerm',
      'filterBy',
      'orderBy',
      'sortDir'
    ]),
    ...mapGetters('auth', ['profile']),
    tableColumnsName() {
      return [
        {
          field: 'contact',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'contact',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'contact',
          label: 'Id',
          sortable: true
        },
        { field: 'firmName', label: 'Company', sortable: true },
        { field: 'contactTypeName', label: 'Type', sortable: true },
        { field: 'fullName', label: 'Name', sortable: true },
        { field: 'emailAddress', label: 'Email', sortable: true },
        { field: 'phoneNo', label: 'Phone', sortable: false },
        {
          field: 'contact',
          label: '',
          sortable: false,
          class: 'custom-column-120'
        }
      ]
    },
    pages() {
      return Math.ceil(this.contacts.count / this.pageSize)
    },
    offset() {
      return (this.page - 1) * this.pageSize
    },
    _pageSize: {
      get() {
        return parseInt(this.pageSize)
      },
      set(value) {
        this.setPageSize(value)
      }
    },
    _searchTerm: {
      get() {
        return this.searchTerm
      },
      set(value) {
        this.setSearchTerm(value)
      }
    },
    _filterBy: {
      get() {
        return parseInt(this.filterBy)
      },
      set(value) {
        this.setFilterBy(value)
      }
    },
    _orderBy: {
      get() {
        return this.orderBy
      },
      set(value) {
        this.setOrderBy(value)
      }
    },
    _sortBy: {
      get() {
        return this.sortBy
      },
      set(value) {
        this.setSortDir(value)
      }
    }
  },
  methods: {
    ...mapActions('contacts', [
      'getContacts',
      'getContact',
      'setSearchTerm',
      'setPageSize',
      'setFilterBy',
      'setOrderBy',
      'setSortDir',
      'saveContact',
      'mergeContacts',
      'addContact',
      'setFilterOptions'
    ]),
    ...mapActions('lookups', ['setLookups']),
    closeModal() {
      this.actionContactEdit = null
      this.actionContactAdd = null
      this.actionMerge = null
      this.actionDrives = null
    },
    setChecked(id) {
      console.log('Checking', id)
    },
    async setOrder(column, sortBy) {
      this.page = 1
      this._sortBy = sortBy
      this._orderBy = column.field
      await this.search(1, this.searchTerm)
    },
    async search(page, searchTerm) {
      // Load up the Contacts
      try {
        if (!this.isLoading) {
          this.isLoading = true
          this.page = page
          await this.getContacts({
            page: this.page,
            status: this.status,
            offset: this.offset,
            sortBy: this.sortDir,
            orderBy: this.orderBy,
            pageSize: this.pageSize,
            searchTerm: searchTerm,
            firm: this.profile.firm,
            type: this.filterBy
          })
          this.isLoading = false
        }
      } catch (e) {
        console.log('Error', e)
      }
    },
    async editContact(value) {
      await this.setLookups({
        keys: ['ContactType', 'Salutation'],
        firm: value.firm,
        refresh: true
      })
      this.actionContactEdit = await this.getContact(value.contact)
    },
    newContact() {
      let contact = {
        firm: this.profile.firm,
        contactType: this._filterBy,
        firstName: '',
        lastName: '',
        salutation: 0,
        notes: '',
        insuranceId: '',
        insuranceNumber: '',
        isCompany: this.isCompany,
        timezone: 12,
        language: 1
      }
      this.addContact(contact)
      this.actionContactAdd = true
    },
    async sendContact(data) {
      await this.saveContact(data)
      await this.search()
      this.actionContactEdit = null
      this.actionContactAdd = null
    },
    confirmContactMerge() {
      this.actionMerge = true
    },
    async performContactMerge() {
      let ids = ''
      this.actionMerge = null
      for (let contact of this.contacts.items) {
        if (contact.isChecked) {
          if (ids !== '') {
            ids += ','
          }
          ids += contact.contact
        }
      }
      await this.mergeContacts(ids)
      await this.search()
    },
    viewTestDrives(data) {
      this.actionDrives = data
    },
    allowEdit(row) {
      let _allow = true
      if (this.isCompany && row.firm === 1 && this.profile.firm !== 1) {
        _allow = false
      }
      return _allow
    }
  }
}
</script>
<style lang='scss' scoped >
.table-responsive.disabled {
  position: relative;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.5);
  }
}
.selectRecord {
  outline: 1px solid blue;
}
.listingWrapper {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/listings/contact-listing.vue